import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { LoginForm } from "@baseline/web/components/auth/LoginForm";

export const Route = createFileRoute("/login")({
	validateSearch: (search: Record<string, unknown>) => ({
		redirect:
			typeof search.redirect === "string" ? search.redirect : undefined,
	}),
	component: Login,
});

function Login() {
	const navigate = useNavigate();
	const { redirect } = Route.useSearch();

	function handleSuccess(): void {
		if (redirect) {
			try {
				const target = new URL(redirect, window.location.origin);
				if (target.origin === window.location.origin) {
					window.location.href = target.pathname + target.search;
					return;
				}
			} catch {
				// Invalid URL — fall through to home
			}
		}
		navigate({
			to: "/",
			search: {
				mode: undefined,
				tag: undefined,
				type: undefined,
				summary: undefined,
			},
		});
	}

	return (
		<LoginForm
			redirectPath={redirect}
			onSuccess={handleSuccess}
			signupUrl="/signup"
		/>
	);
}
